<template>
  <div :id="componentId" class="sp-image-component" :style="sectionStyle">
    <div class="sp-image-wrapper">
      <img
        v-if="imageUrl"
        class="sp-image-main"
        referrerpolicy="no-referrer"
        :src="imageUrl"
      />
      <div v-else class="sp-image-placeholder">
        <i class="el-icon-picture-outline"></i>
        <span>暂无图片</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpImage',
  props: {
    componentId: {
      type: String,
      default: 'sp_image'
    }
  },
  data() {
    return {
      imageUrl: '',
      bgImageUrl: '',
      bgColor: '#ffffff'
    };
  },
  computed: {
    sectionStyle() {
      const style = {
        backgroundColor: this.bgColor
      };
      if (this.bgImageUrl) {
        style.backgroundImage = `url(${this.bgImageUrl})`;
        style.backgroundRepeat = 'no-repeat';
        style.backgroundPosition = 'center';
        style.backgroundSize = 'cover';
      }
      return style;
    }
  }
};
</script>

<style scoped>
.sp-image-component {
  position: relative;
  width: 100%;
  min-height: 120px;
  padding: 16px 0;
  cursor: pointer;
  box-sizing: border-box;
}

.sp-image-wrapper {
  position: relative;
  width: calc(100% - 24px);
  margin: 0 auto;
  background: #f5f7fa;
  border-radius: 8px;
  overflow: hidden;
}

.sp-image-main {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.sp-image-placeholder {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  background: #f5f7fa;
}

.sp-image-placeholder i {
  font-size: 48px;
  margin-bottom: 8px;
  color: #c0c4cc;
}
</style>
